import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Dropdown from "react-bootstrap/Dropdown";
import { Container, Modal } from "react-bootstrap";
import { useContext, useEffect, useRef, useState } from "react";
import {
  RemovRoles,
  RemoveRefreshToken,
  RemoveToken,
  RemoveUser,
  SetRefreshToken,
  SetToken,
} from "../../utils/helper/helper";
import { Link, useNavigate } from "react-router-dom";
import { OverlayTrigger, Tooltip, Button } from "react-bootstrap";
import { ImageUrl } from "../../utils/config/config";
import * as icons from "react-bootstrap-icons";
import { PlayerGetSubscribeManager, RefreshToken } from "../../redux/auth-reducer/auth-service";
import { Context } from "../../redux/Context";
import { useDispatch } from "react-redux";
import { setAuthToeken } from "../../redux/auth-reducer/auth-reducer";
import { Loader } from "rsuite";

// Import jwt-decode to decode our JWT token
import { jwtDecode } from "jwt-decode";

const TOKEN_REFRESH_THRESHOLD = 60 * 1000; // 60 seconds

function TopNavbar({ sidebarfun }) {
  const roles = localStorage.getItem("role");
  const [showNotification, setShowNotification] = useState(false);
  const [showQuery, setShowQuery] = useState(false);
  const [signalRNotification, setSignalRNotification] = useState([]);
  const [signalRQuery, setSignalRQuery] = useState([]);
  const [notificationCount, setNotificationCount] = useState();
  const [queryCount, setQueryCount] = useState();
  const [auctionCreateData, setAuctionCreateData] = useState([]);
  const { hubConnection } = useContext(Context);
  const dispatch = useDispatch();
  const [dataItem, setDataItem] = useState();
  // This state is used for the multi-user login modal
  const [showModal, setShowModal] = useState(false);
  const [showTimeoutModal, setShowTimeoutModal] = useState(false);

  const defaultInactivityTime = 20 * 60 * 1000;
  const [inactivityTime, setInactivityTime] = useState(defaultInactivityTime);

  const timerIdRef = useRef(null);
  const logoutTimerRef = useRef(null);

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("isToken");
    if (token) {
      dispatch(setAuthToeken(token));
      try {
        const decoded = jwtDecode(token);
        const expiryTime = decoded.exp * 1000;
        const now = Date.now();
        if (expiryTime > now) {
          setInactivityTime(expiryTime - now);
        } else {
          logout();
        }
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
  }, [dispatch]);

  async function logout() {
    RemoveToken();
    RemoveRefreshToken();
    RemovRoles();
    localStorage.removeItem("details");
    localStorage.removeItem("isUser");
    localStorage.removeItem("img");
    localStorage.removeItem("checkoutValue");
    localStorage.removeItem("itemnav");
    localStorage.removeItem("modalShown");
    localStorage.removeItem("showTimeOutModal");
    localStorage.removeItem("sesstionID");
    localStorage.removeItem("notiMess");
    localStorage.clear();
    navigate("/Home");
  }

  async function clearCaches() {
    if ("caches" in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map((name) => caches.delete(name)));
    }
  }

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (showModal) {
        logout();
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [showModal]);

  const resetInactivityTimer = () => {
    if (timerIdRef.current) clearTimeout(timerIdRef.current);
    timerIdRef.current = setTimeout(() => {
      setShowTimeoutModal(true);
      localStorage.setItem("showTimeOutModal", "true");
      logoutTimerRef.current = setTimeout(() => {
        logout();
      }, 5000);
    }, inactivityTime);
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll"];
    const eventHandler = () => {
      if (!showTimeoutModal) {
        resetInactivityTimer();
      }
    };

    events.forEach((event) => window.addEventListener(event, eventHandler));
    resetInactivityTimer();

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, eventHandler)
      );
      if (timerIdRef.current) clearTimeout(timerIdRef.current);
      if (logoutTimerRef.current) clearTimeout(logoutTimerRef.current);
    };
  }, [showTimeoutModal, inactivityTime]);

  useEffect(() => {
    const checkInterval = setInterval(() => {
      const token = localStorage.getItem("isToken");
      if (token) {
        try {
          const decoded = jwtDecode(token);
          const expiryTime = decoded.exp * 1000;
          const now = Date.now();
          const timeRemaining = expiryTime - now;
          if (
            timeRemaining < TOKEN_REFRESH_THRESHOLD &&
            inactivityTime > timeRemaining
          ) {
            RefreshToken()
              .then((response) => {
                if (response?.newToken) {
                  localStorage.setItem("isToken", response.newToken);
                  dispatch(setAuthToeken(response.newToken));
                  const newDecoded = jwtDecode(response.newToken);
                  const newExpiryTime = newDecoded.exp * 1000;
                  setInactivityTime(newExpiryTime - Date.now());
                }
              })
              .catch((err) => {
                console.error("Error refreshing token:", err);
                logout();
              });
          }
        } catch (error) {
          console.error("Error checking token expiry:", error);
        }
      }
    }, 15000);

    return () => clearInterval(checkInterval);
  }, [dispatch, inactivityTime, navigate]);

  const isUser = JSON.parse(localStorage.getItem("isUser"));
  const fullName = isUser?.fullName;
  const userEmail = isUser?.email;

  useEffect(() => {
    if (!fullName || fullName.trim() === "") {
      RemoveToken();
      RemoveRefreshToken();
      RemoveUser();
      RemovRoles();
      navigate("/login");
    }
  }, [fullName, navigate]);


  // useEffect(() => {
  //   if (hubConnection) {
  //     hubConnection.on("ReceiveNotification", (data) => {
  //       // Check if the notification should be visible to the current user
  //       const isVisible =
  //         data?.roleId === 4
  //           ? userEmail === "xcutta2500@gmail.com" // Only visible to this email if roleId is 4
  //           : true; // Visible to all for other roleIds

  //       if (isVisible && data?.message) {
  //         // Update localStorage and notification state only if visible
  //         localStorage.setItem("notiMess", data?.message);
  //         let currentCount = parseInt(
  //           localStorage.getItem("messageCount") || 0,
  //           10
  //         );

  //         currentCount += 1;
  //         localStorage.setItem("messageCount", currentCount);
  //         setSignalRNotification(data);
  //         setNotificationCount(currentCount);
  //       }

  //     });

  //     hubConnection.on("ContactUs", (queryData) => {
  //       setSignalRQuery(queryData[0]);
  //       setQueryCount(queryData?.length);
  //     });

  //     return () => {
  //       hubConnection.off("ReceiveNotification");
  //       hubConnection.off("ContactUs");
  //     };

  //   }

  // }, [hubConnection, userEmail]);


  useEffect(() => {
    if (hubConnection) {
      hubConnection.on("ReceiveNotification", (data) => {
        const isVisible = data?.roleId === 4 ? isUser?.email === "xcutta2500@gmail.com" : data?.createdBy !== isUser?.userId;
        if (isVisible && data?.message) {
          localStorage.setItem("notiMess", data?.message);
          let currentCount = parseInt(
            localStorage.getItem("messageCount") || 0,
            10
          );
          currentCount += 1;
          localStorage.setItem("messageCount", currentCount);
          setSignalRNotification(data);
          setNotificationCount(currentCount);
        }
      });
      hubConnection.on("ContactUs", (queryData) => {
        setSignalRQuery(queryData[0]);
        setQueryCount(queryData?.length);
      });

      return () => {
        hubConnection.off("ReceiveNotification");
        hubConnection.off("ContactUs");
      };
    }
  }, [hubConnection, isUser?.email, isUser?.userId]);


  useEffect(() => {
    if (hubConnection) {
      hubConnection.on("ReceiveAuctionNotification", (data) => {
        localStorage.setItem("auctionCreate", data[0]?.message);
        setAuctionCreateData(data[0]?.message);
      });
    }
  }, [hubConnection]);

  const mes = localStorage.getItem("notiMess");
  const mesAuction = localStorage.getItem("auctionCreate");

    const getDestinationPath = (message) => {
    // Check if the message contains the phrase "secondary market"
    if (message && message.includes('secondary market')) {
      return '/Player/Secondary_Market';
    }
    // If not, default to the AuctionPlayer path
    return '/Player/AuctionPlayer';
  };

  // Get the determined path
  const destinationPath = getDestinationPath(mesAuction);
  
  const handleLandingPage = () => {
    navigate("/");
    localStorage.removeItem("itemnav");
  };

  const handleQueryPage = () => {
    navigate("/WebAdmin/Query");
  };

  const handleNotificationClick = () => {
    setShowNotification(!showNotification);
    localStorage.removeItem("notiMess");
    localStorage.removeItem("messageCount");
  };

  const handleQueryClick = () => {
    setShowQuery(!showQuery);
  };

  const TokenInvalid = () => localStorage.getItem("TokenInvalid");
  useEffect(() => {
    let tokendata = TokenInvalid();
    if (tokendata === "true") {
      localStorage.removeItem("TokenInvalid");
      SetToken(null);
      SetRefreshToken(null);
      navigate("/login");
    }
  }, [TokenInvalid()]);

  const handleNotificationPageManager = () => {
    navigate("/SuperAdmin/SuperNotification");
    localStorage.removeItem("itemnav");
  };

  const handleNotificationPagePlayer = () => {
    navigate("/Player/Notification");
    localStorage.removeItem("itemnav");
    localStorage.removeItem("auctionCreate");
  };

  // auctionCreateData?.map((item) => {
  //   var auctionInfo = item?.message;
  //   var auctionName = auctionInfo.split("auction")[0];
  //   var auctionmsg = auctionInfo.split("auction")[1];
  // });

  useEffect(() => {
    if (hubConnection) {
      hubConnection.on("ReceiveUserStatus", (data) => {
        setDataItem(data);
      });
      return () => {
        hubConnection.off("ReceiveUserStatus");
      };
    }
  }, [hubConnection]);

  useEffect(() => {
    if (dataItem === isUser?.email) {
      setShowModal(true);
      localStorage.setItem("modalShown", dataItem);
    }
  }, [dataItem, isUser]);

  useEffect(() => {
    if (showModal) {
      const timer = setTimeout(() => {
        logout();
        setShowModal(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showModal]);

  useEffect(() => {
    const modalShown = localStorage.getItem("modalShown");
    const modalShownTimeOut = localStorage.getItem("showTimeOutModal");

    if (modalShown || modalShownTimeOut) {
      localStorage.removeItem("modalShown");
      localStorage.removeItem("showTimeOutModal");
      navigate("/login");
    }
  }, [navigate]);

  const sameUseSaty = async () => {
    await RefreshToken();
  };

  const handleStayLoggedIn = () => {
    sameUseSaty();
    setShowTimeoutModal(false);
    localStorage.removeItem("showTimeOutModal");
    resetInactivityTimer();
  };

  return (
    <>
      <div className="topbar">
        <Container fluid>
          {dataItem === isUser?.email && (
            <Modal show={showModal} centered>
              <Modal.Header >
                <Modal.Title>
                  <b>New Session Detected</b>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                Your session is logged out because a new session is created with
                the same credentials by another user. Please log in again to
                continue.
              </Modal.Body>
            </Modal>
          )}

          {/* Inactivity Timeout Modal */}
          <Modal show={showTimeoutModal} centered>
            <Modal.Header>
              <Modal.Title>
                <b>Inactivity Session Time-out</b>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              You have been inactive for a while. Your session will expire soon.
              Please click "Stay Logged In" if you wish to continue your
              session.
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={handleStayLoggedIn}>
                Stay Logged In
              </Button>
            </Modal.Footer>
          </Modal>
          <Row className="align-items-center ">
            <Col xs={6} className=" mob">
              <div className="logo-image">
                <Link to="/Home">
                  <img src="/image/logo1.png" width={115} alt="logo" />
                </Link>
              </div>
            </Col>
            <Col xs={6} className="text-right mob">
              <img
                src="/image/minu-icon.svg"
                onClick={sidebarfun}
                className="icon-menue"
                alt="menu icon"
              />
            </Col>
            <Col md="6" className="desk">
              <div className="innetr-group p-2">
                <div className="group-top-bar ms-0">
                  <div className="logo-image">
                    <Link to="/Home">
                      <img src="/image/logo1.png" width={115} alt="logo" />
                    </Link>
                  </div>
                  <div className="icon-bar">
                    <img
                      src="/image/minu-icon.svg"
                      onClick={sidebarfun}
                      className="icon-menue"
                      alt="menu icon"
                    />
                  </div>
                </div>
              </div>
            </Col>
            <Col md="6">
              <div className="d-flex p-2 align-items-center justify-content-end dropdown-section">
                <div className="me-3" onClick={handleLandingPage}>
                  <icons.HouseDoor className="home-icon-top" />
                </div>
                {roles === "Web Admin" ? (
                  <Dropdown
                    className="notification-message"
                    onClick={handleQueryClick}
                  >
                    <Dropdown.Toggle
                      variant="success"
                      id="dropdown-basic"
                      className="notification-icon"
                    >
                      <icons.Bell
                        onClick={handleQueryClick}
                        className="bell-notify"
                      />
                      {signalRQuery?.length ? (
                        <span
                          className="badge-notification"
                          onClick={handleQueryClick}
                        >
                          !
                        </span>
                      ) : null}
                    </Dropdown.Toggle>
                    {signalRQuery?.length === 0 ? (
                      <Dropdown.Menu>No Data Found</Dropdown.Menu>
                    ) : (
                      <Dropdown.Menu>
                        {showQuery && (
                          <div onClick={handleQueryPage}>
                            {signalRQuery?.message}
                          </div>
                        )}
                      </Dropdown.Menu>
                    )}
                  </Dropdown>
                ) : roles === "Manager" ? (
                  <Dropdown className="notification-message">
                    <Dropdown.Toggle
                      variant="success"
                      id="dropdown-basic"
                      className="notification-icon"
                    >
                      <icons.Bell
                        onClick={handleNotificationClick}
                        className="bell-notify"
                      />
                      {signalRNotification?.length === 0 ||
                        signalRNotification?.createdBy === isUser?.userId ? null : (
                        <span
                          className="badge-notification"
                          onClick={handleNotificationClick}
                        >
                          !
                        </span>
                      )}

                    </Dropdown.Toggle>
                    {signalRNotification?.length === 0 ||
                      signalRNotification?.createdBy === isUser?.userId ? (
                      <Dropdown.Menu>No Data Found</Dropdown.Menu>
                    ) : (
                      <Dropdown.Menu>
                        {showNotification && (
                          <div onClick={handleNotificationPageManager}>
                            {signalRNotification?.message}
                          </div>
                        )}
                      </Dropdown.Menu>
                    )}
                  </Dropdown>
                ) : (
                  <Dropdown className="notification-message">
                    <Dropdown.Toggle
                      variant="success"
                      id="dropdown-basic"
                      className="notification-icon"
                    >
                      <icons.Bell className="bell-notify" />
                      {mesAuction?.length > 0 ? (
                        <span className="badge-notification1">1</span>
                      ) : null}
                      {mes ? (
                        <span className="badge-notification">1</span>
                      ) : null}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {mes ? (
                        <Link
                          to="/Player/Notification"
                          onClick={handleNotificationClick}
                        >
                          {mes}
                        </Link>
                      ) : mesAuction ? (
                          <Link
                            // Use the dynamically determined path
                            to={destinationPath}
                            onClick={handleNotificationPagePlayer}
                          >
                            {mesAuction}
                          </Link>
                        ) : (
                          <p>No Data Found</p>
                        )}
                    </Dropdown.Menu>
                  </Dropdown>
                )}


                {isUser?.userImage === null ? (
                  <img
                    src="/image/profileDefault.png"
                    width="50"
                    className="rounded-circle me-3"
                    alt="profile"
                  />
                ) : (
                  <img
                    src={ImageUrl + isUser?.userImage}
                    className="profile-image"
                    alt="profile"
                  />
                )}
                <Dropdown>
                  {roles}
                  <Dropdown.Toggle
                    variant="none"
                    className="d-flex align-items-center p-0"
                  >
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="tooltip1">{fullName}</Tooltip>}
                    >
                      <div className="text-hide">
                        {isUser?.fullName === null ? <Loader /> : fullName}
                      </div>
                    </OverlayTrigger>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {roles === "Web Admin" ? (
                      <Dropdown>
                        <Link to="/WebAdmin/profile" className="item-link">
                          Profile
                        </Link>
                      </Dropdown>
                    ) : roles === "Super Admin" ? (
                      <Dropdown>
                        <Link className="item-link" to="/SuperAdmin/Profile">
                          Profile
                        </Link>
                      </Dropdown>
                    ) : (
                      <Dropdown>
                        <Link className="item-link" to="/Player/Profile">
                          Profile
                        </Link>
                      </Dropdown>
                    )}
                    {roles === "Web Admin" ? (
                      <Dropdown>
                        <Link
                          className="item-link"
                          to="/WebAdmin/ChangePassword"
                        >
                          Change Password
                        </Link>
                      </Dropdown>
                    ) : roles === "Super Admin" ? (
                      <Dropdown>
                        <Link
                          className="item-link"
                          to="/SuperAdmin/ChangePassword"
                        >
                          Change Password
                        </Link>
                      </Dropdown>
                    ) : (
                      <Dropdown>
                        <Link className="item-link" to="/Player/ChangePassword">
                          Change Password
                        </Link>
                      </Dropdown>
                    )}
                    <Dropdown.Item onClick={logout}>Logout</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default TopNavbar;
